import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './styles/index.css'
// highlight.js 代码高亮主题 (github light), 供 AssistantMessage 渲染的 <pre><code> 着色.
import 'highlight.js/styles/github.css'

// 启动顺序: Pinia 必须先于 router (router 守卫里要用 useAuthStore()).
const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
